/**
 * Componente minimalista de alternância de tema (Light / Dark Mode).
 * Estilizado como botão glass-card de 40x40px com ícones vetoriais elegantes.
 *
 * @module components/ThemeToggle
 */

/**
 * Botão minimalista para alternar entre modo claro e escuro.
 *
 * @param {{ isDarkMode: boolean, onToggle: () => void }} props
 * @returns {JSX.Element}
 */
export default function ThemeToggle({ isDarkMode, onToggle }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={isDarkMode ? "Mudar para tema claro" : "Mudar para tema escuro"}
      title={isDarkMode ? "Tema: Escuro (Clique para mudar para Claro)" : "Tema: Claro (Clique para mudar para Escuro)"}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "var(--border-subtle)";
        e.currentTarget.style.borderColor = "var(--text-muted)";
        e.currentTarget.style.color = "var(--text-primary)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "var(--bg-surface-elevated)";
        e.currentTarget.style.borderColor = "var(--border-color)";
        e.currentTarget.style.color = "var(--text-secondary)";
      }}
      style={{
        width: 34,
        height: 34,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        cursor: "pointer",
        border: "1px solid var(--border-color)",
        borderRadius: "var(--radius-sm)",
        background: "var(--bg-surface-elevated)",
        color: "var(--text-secondary)",
        transition: "all var(--transition-fast)",
        boxSizing: "border-box",
      }}
    >
      {isDarkMode ? (
        // Ícone Minimalista de Lua (Modo Escuro ativo -> clica para ir para Claro)
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      ) : (
        // Ícone Minimalista de Sol (Modo Claro ativo -> clica para ir para Escuro)
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
        </svg>
      )}
    </button>
  );
}
